import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";
import { finishSso, startSso } from "../auth/Sso.js";

/**
 * /auth/callback — where Google or Microsoft (via Cognito) send the browser
 * back. Exchanges the code for tokens and signs in; on a refusal (for example
 * "There's no dashboard account for …") it returns to the sign-in page with
 * the message, rather than leaving the person on a blank screen.
 */
export default function SsoCallback() {
  const { completeSso } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Signing you in…");

  useEffect(() => {
    let cancelled = false;
    finishSso(location.search)
      .then((result) => {
        if (cancelled) return;
        if (result.retry) {
          setStatus("Finishing sign-in…");
          startSso(result.retry, { isRetry: true });
          return;
        }
        completeSso(result.tokens);
        navigate("/", { replace: true });
      })
      .catch((err) => {
        if (!cancelled) navigate("/login", { replace: true, state: { ssoError: err.message } });
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="sso-callback" role="status" aria-live="polite">
      {status}
    </div>
  );
}
